import React from "react";
import { Row, Col, CardBody } from "reactstrap";

const ProductosVale = (props) => {
  const esMedicamento = props.tipoProducto === "Medicamento";
  const esServicio = props.tipoProducto === "Servicio";

  const getMedicamentoOptions = (producto) => {
    if (props.getMedicamentoOptions) {
      return props.getMedicamentoOptions(producto);
    }

    const source = props.productosServiciosFilter && props.productosServiciosFilter.length > 0
      ? props.productosServiciosFilter
      : props.productosServicios || [];

    return source.filter((prodServ) => {
      if (prodServ.idCatTipoproducto !== 2) {
        return false;
      }

      if (producto.principioActivo && producto.principioActivo !== prodServ.principioActivo) {
        return false;
      }

      if (producto.concentracion && producto.concentracion !== prodServ.concentracion) {
        return false;
      }

      return prodServ.nombreComercial && prodServ.nombreComercial !== "undefined";
    });
  };

  const renderDescripcionDatalist = (producto, index) => {
    if (props.getDescripcionOptions) {
      const source = props.getDescripcionOptions(producto, index) || [];
      return (
        <datalist autoComplete="off" id={`listaInsumos${index + props.tipoProducto}`}>
          {source.map((prodServ) => (
            <option
              className="Option"
              key={`${props.tipoProducto}-${producto._tempId || index}-${prodServ.idCatProducto || prodServ.idCatServicio || prodServ.numIdentificacion || prodServ.servicio}`}
              value={prodServ.servicio != null ? `${prodServ.servicio}` : `${prodServ.nombreComercial} - ${prodServ.numIdentificacion}`}>
              {prodServ.servicio != null ? prodServ.servicio : `${prodServ.nombreComercial} - ${prodServ.principioActivo}`}
            </option>
          ))}
        </datalist>
      );
    }

    if (esServicio) {
      const source = props.serviciosFiltradosPorTipoServicio || props.productosServicios || [];
      return (
        <datalist autoComplete="off" id={`listaInsumos${index + props.tipoProducto}`}>
          {source.map((prodServ) => (
            <option
              className="Option"
              key={`${props.tipoProducto}-${producto._tempId || index}-${prodServ.idCatServicio || prodServ.servicio}`}
              value={`${prodServ.servicio}`}>
              {prodServ.servicio}
            </option>
          ))}
        </datalist>
      );
    }

    const source = esMedicamento ? getMedicamentoOptions(producto) : props.productosServicios || [];

    return (
      <datalist autoComplete="off" id={`listaInsumos${index + props.tipoProducto}`}>
        {source.map((prodServ) => (
          <option
            className="Option"
            key={`${props.tipoProducto}-${producto._tempId || index}-${prodServ.idCatProducto || prodServ.idCatServicio || prodServ.numIdentificacion}`}
            value={`${prodServ.nombreComercial} - ${prodServ.numIdentificacion}`}>
            {prodServ.nombreComercial} - {prodServ.principioActivo}
          </option>
        ))}
      </datalist>
    );
  };

  return (
    <CardBody autoComplete="off" key={props.tipoProducto} className={!esServicio ? "mt-4" : ""}>
      <Row className="mb-3">
        <Col>
          <button
            name={props.tipoProducto}
            id={props.tipoProducto}
            className="btn btn-primary-orange-umo w-md waves-effect waves-light"
            type="button"
            disabled={props.disabledInsumo}
            onClick={props.nuevoRenglon}
            style={{
              marginRight: "2.5rem",
              background: "#ff9933",
              color: "white",
              fontWeight: "bold",
            }}>
            Agregar {props.tipoProducto}
          </button>
        </Col>
      </Row>
      <div className="table-responsive">
        <table id={`tabla-${props.tipoProducto}`} className="table table-hover table-centered table-nowrap mb-0">
          <thead>
            <tr>
              <th style={{ width: "25%" }} hidden={!esMedicamento} scope="col">
                PRINCIPIO<br></br>ACTIVO
              </th>
              <th style={{ width: "6%" }} hidden={!esMedicamento} scope="col">
                CONCENTRACION
              </th>
              {!esMedicamento ? (
                <th style={{ width: "80%" }} scope="col">
                  {props.tipoProducto.toUpperCase()}
                </th>
              ) : (
                <th style={{ width: "47%" }} scope="col">
                  {props.tipoProducto.toUpperCase()}
                </th>
              )}
              <th style={{ width: "15%" }} scope="col">
                {!esServicio ? "PIEZAS" : "CICLO"}
              </th>
              <th scope="col">ELIMINAR</th>
            </tr>
          </thead>
          <tbody>
            {props.productos &&
              props.productos.map((producto, index) => (
                <tr key={producto._tempId || `${props.tipoProducto}-${index}`}>
                  <td hidden={!esMedicamento}>
                    <input
                      autoComplete="off"
                      type="text"
                      onChange={(e) => props.changePrincipioActivo(e, props.tipoProducto, index)}
                      onFocus={() => props.handlePrincipioActivoFocus && props.handlePrincipioActivoFocus(props.tipoProducto, index)}
                      list={`listaPrincipiosActivos${index + props.tipoProducto}`}
                      value={producto.principioActivo}
                      className="form-control"
                    />

                    <datalist autoComplete="off" id={`listaPrincipiosActivos${index + props.tipoProducto}`}>
                      {(props.getPrincipioActivoOptions
                        ? props.getPrincipioActivoOptions(producto, index)
                        : props.principioActivoFilter
                      ).map((principioActivo) => (
                        <option key={`${props.tipoProducto}-${producto._tempId || index}-${principioActivo}`} value={principioActivo}>
                          {principioActivo}
                        </option>
                      ))}
                    </datalist>
                  </td>
                  <td hidden={!esMedicamento}>
                    <input
                      type="text"
                      autoComplete="off"
                      onChange={(e) => props.changeConcentracion(e, index)}
                      onFocus={() => props.handleConcentracionFocus && props.handleConcentracionFocus(props.tipoProducto, index)}
                      list={`listaConcentraciones${index + props.tipoProducto}`}
                      value={producto.concentracion}
                      className="form-control"
                    />
                    <datalist autoComplete="off" id={`listaConcentraciones${index + props.tipoProducto}`}>
                      {(props.getConcentracionOptions
                        ? props.getConcentracionOptions(producto, index)
                        : props.concentracionesFilter
                      ).map((concentracion) => (
                        <option key={`${props.tipoProducto}-${producto._tempId || index}-${concentracion}`} value={concentracion}>
                          {concentracion}
                        </option>
                      ))}
                    </datalist>
                  </td>
                  <td>
                    <input
                      value={producto.descripcion}
                      autoComplete="off"
                      type="text"
                      id={`productoservicio${index + props.tipoProducto}`}
                      onChange={(e) => props.changeInsumoCat(e, index)}
                      onFocus={() => props.handleDescripcionFocus && props.handleDescripcionFocus(props.tipoProducto, index)}
                      list={`listaInsumos${index + props.tipoProducto}`}
                      maxLength={199}
                      className="form-control"
                    />
                    {renderDescripcionDatalist(producto, index)}
                  </td>
                  <td>
                    <input
                      value={producto.piezas}
                      autoComplete="off"
                      disabled={props.disabledInsumo}
                      type="number"
                      min="0"
                      onChange={(e) => props.changeInsumoPiezas(e, props.tipoProducto, index)}
                      className="form-control"
                    />
                  </td>

                  <td>
                    <button
                      type="button"
                      className="btn btn-primary-orange-umo w-md waves-effect waves-light"
                      onClick={() => {
                        props.setTipoProductoEliminar(props.tipoProducto);
                        props.setIndexInsumoBorrado(index);
                        props.setUISweetAlert({
                          ...props.UISweetAlert,
                          confirm_alert_delete_insumo: true,
                        });
                      }}>
                      ELIMINAR
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </CardBody>
  );
};

export default ProductosVale;
